import { PatientSimple } from '@dreryk/egabinet-patient-frontend-api';

import { createTranslatedText, Translate } from '@dreryk/react-common';
import { StyledFlex } from '@dreryk/react-components';

import { getPatientReferenceIdentifierTranslatableText } from '~libs.shared.patient';
import { getPatientName } from '~libs.desktop.shared.appointments-timetable';
import { PatientGroups } from '~libs.desktop.shared.patient-groups';

import { calendarTranslationKeys } from '../../../translations';

import { StyledCalendarPatientSection, StyledName } from './CalendarPatientSection.styled';

type CalendarPatientSectionProps = {
   readonly patient: PatientSimple;
};

export const CalendarPatientSection = (props: CalendarPatientSectionProps): JSX.Element => {
   return (
      <StyledCalendarPatientSection>
         <StyledFlex direction='column' gap='8px'>
            <Translate>{calendarTranslationKeys.bookNextVisitForPatient}</Translate>
            <StyledName>{getPatientName(props.patient)}</StyledName>
            <Translate>
               {getPatientReferenceIdentifierTranslatableText(
                  props.patient.referenceIdentifier,
                  createTranslatedText('')
               )}
            </Translate>
            <PatientGroups patientGroups={props.patient.patientGroups} />
         </StyledFlex>
      </StyledCalendarPatientSection>
   );
};
